// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"3a1cc1fd","71":"598b68d2","137":"62c72114","224":"130430fe","453":"1182cff4"}[chunkId] + ".chunk.js";
};